import React, { useState } from 'react'
import Answers from './Answers'
import AnswerContents from './AnswerContents'
import { AnswerItem } from './AnswerItem'
import CampaignHeader from './CampaignHeader'
import survey from '../utils/survey'
import Thanks from './Thanks'

// https://abema.esa.io/posts/16867
export interface Campaign {
  campaignId: number,
  surveyId: string,
  adSystemId: string,
  progressTrackingTag: string,
  version: number,
  userId: string,
  tokenId: string,
  skipUrl: string,
  q: {
    page: number;  // memo: survey master上のquestion_idが入る！
    order: number; // memo: 設問はorderで並び替える（orderに設問の表示順が入る、pageではないので注意！！）
    text: string;
    type: number;
    random: boolean;
    hasAnswerButton: boolean;
    a: AnswerItem[];
    img?: undefined;
  }[]
  isPreviewMode?: boolean;
}
declare global {
  interface Window {
    dataLayer: Array<Object>;
  }
}
const dataLayer = window.dataLayer || [];

const CampaignContainer: React.FC<Campaign> = (campaign) => {
  const [answers, setAnswers] = useState<string[]>([])
  const [isFinish, setIsFinish] = useState<boolean>(false)

  const question = campaign.q[0] // とりあえず1問しかないので0番目のqだけ撮ってくる
  const answerItems = question.a
  const url = new URL(window.location.href)
  const params = url.searchParams
  const hasAnswerButton = params.get('hasAnswerButton') === '1'
  const benefitAppealPattern = params.get('benefitAppealPattern') || undefined

  const submit = (value: string) => {
    // answer_values の型は JSONArray のstring なので、必ず Array を渡す(mine側でエラーとなってしまうため)
    const answer_values = value ? [value] : answers
    dataLayer.push({
      event: 'answer_ad_survey',
      uid: campaign.userId,
      token_id: campaign.tokenId,
      campaign_id: campaign.campaignId || 0,
      version: campaign.version || "1.0",
      question_page: question.page,
      survey_id: `"${campaign.surveyId}"`, // "42"などの整数文字列が入ってきた場合、'"'で囲わないとmineに整数と判定されて型エラーで弾かれてしまう
      ad_system_id: campaign.adSystemId,
      progress_tracking_tag: campaign.progressTrackingTag,
      answer_values: JSON.stringify(answer_values)
    })

    dataLayer.push({
      ibs_url: process.env.REACT_APP_TRK_HOST || "stg-ibs-trk.a-mpd.com",
      event: 'i_complete_answer',
      progress_tracking_tag: campaign.progressTrackingTag
    })

    if (survey.isSkippable()) {
      if (campaign.skipUrl) {
        fetch(campaign.skipUrl);
      }
      // gtm がログを送信できないこともあるので、一旦500msスリープする
      setTimeout(() => survey.close(), 500)
    } else {
      // Thanks ページ書き換え
      setIsFinish(true)
    }
  }

  const isCheckbox = question.type === 2 // Checkbox
  let row = Math.ceil(answerItems.length / 2)
  row = (((isCheckbox || hasAnswerButton) && (answerItems.length % 2  === 0))) ? row + 1 : row

  return (
    <>
      <CampaignHeader {...{ title: question.text }} />
      <AnswerContents {...{ row }}>
        <Answers {...{
          items: answerItems,
          value: answers,
          hasAnswerButton,
          benefitAppealPattern,
          type: question.type,
          row,
          onClick: (value) => {
            setAnswers(value)
          },
          submit: campaign.isPreviewMode ? () => {} : submit
        }} />
      </AnswerContents>
      <Thanks isOpen={isFinish} />
    </>
  )
}

export default CampaignContainer
